import { useTranslation } from 'react-i18next'
import cx from 'helpers/cx'

import { AddIcon } from '@pleio/icons/add'

import DashedBox from 'js/components/DashedBox/DashedBox'
import IconButton from 'js/components/IconButton'
import { Tooltip } from 'js/components/Tooltip/Tooltip'

import styles from './AddColumnActions.module.css'

export const ADD_COLUMN_BUTTON_WIDTH = '32px'

type AddColumnActionsProps = {
    onAddColumn: (position: 'left' | 'right') => void
    onFocus?: () => void
    onBlur?: () => void
    className?: string
}

const AddColumnActions = ({
    onAddColumn,
    onFocus,
    onBlur,
    className,
}: AddColumnActionsProps) => {
    const { t } = useTranslation()

    const handleAddLeft = () => onAddColumn('left')

    const handleAddRight = () => onAddColumn('right')

    return (
        <div
            onFocus={onFocus}
            onBlur={onBlur}
            className={cx(styles.wrapper, className)}
        >
            <DashedBox>
                <Tooltip
                    content={t('page.add-column')}
                    side="left"
                    followCursor="vertical"
                    delay
                >
                    <IconButton
                        variant="secondary"
                        radiusStyle="none"
                        onClick={handleAddLeft}
                        aria-label={t('page.add-column')}
                    >
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </DashedBox>
            <DashedBox>
                <Tooltip
                    content={t('page.add-column')}
                    side="right"
                    followCursor="vertical"
                    delay
                >
                    <IconButton
                        variant="secondary"
                        radiusStyle="none"
                        onClick={handleAddRight}
                        aria-label={t('page.add-column')}
                    >
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </DashedBox>
        </div>
    )
}

export default AddColumnActions
